<template>
    <div class="alert--danger is-active">
        <p class="alert__copy">
            Are you sure you want to delete?
        </p>
        <div class="alert__buttons">
            <button class="button--tertiary-alt--secondary" @click="confirm" type="button">
                Confirm and Delete
            </button>
            <button class="button--secondary-alt--secondary" @click="close" type="button">
                Cancel
            </button>
        </div>
    </div>
</template>

<script setup>
const emit = defineEmits(['confirm', 'close']);

const confirm = () => emit('confirm');
const close = () => emit('close');
</script>